const debounce = <T extends (...args: unknown[]) => void>(fn: T, waitMs: number) => {
    let timeoutId: ReturnType<typeof setTimeout> | undefined;
    return (...args: Parameters<T>) => {
        if (timeoutId) {
            clearTimeout(timeoutId);
        }
        timeoutId = setTimeout(() => fn(...args), waitMs);
    };
};

export default debounce;